import React from "react";
import Classes from "./Classes";
import Styles from "./Styles";
import ConditionalOutput from "./ConditionalOutput";
import TodoList from "./Todo/TodoList";
import A6 from "../index";

const Practice = () => {
  return(
      <>
        <h1>Practice</h1>
          <TodoList/>
          <ConditionalOutput/>
          <Styles/>
          <Classes/>
          <A6/>
      </>
  )
};

export default Practice;
